import React from 'react';
import { wrapFunctionalComponent } from 'utils/framework';
import Carousel from 'components/Carousel';
import { modal } from 'style/config';
import {
    CARD_GAP,
    CARD_WIDTH,
    CARD_WIDTH_MD,
    CARD_WIDTH_LARGE,
    CARDS_PER_SLIDE_LARGE,
    CARDS_PER_SLIDE,
    CARDS_PER_SLIDE_MD,
    CARD_IMG_SIZE,
    CARD_IMG_SIZE_MD,
    CARD_IMG_SIZE_LARGE
} from 'constants/productCard';
import ProductCard from 'components/Product/ProductCard';
import constants from 'constants/content';
import anaConstants from 'analytics/constants';
import { mountCmsComponentEventData, shouldSentEvent } from 'analytics/utils/cmsComponents';

const {
    COMPONENT_TYPES: { PRODUCT_LIST }
} = constants;

const {
    CMS_COMPONENT_EVENTS: { ITEM_CLICK }
} = anaConstants;

const CardSizes = {
    small: {
        cardWidth: CARD_WIDTH,
        cardsPerSlide: CARDS_PER_SLIDE,
        imageSize: CARD_IMG_SIZE
    },
    large: {
        cardWidth: CARD_WIDTH_LARGE,
        cardsPerSlide: CARDS_PER_SLIDE_LARGE,
        imageSize: CARD_IMG_SIZE_LARGE
    },
    horizontal: {
        cardWidth: CARD_WIDTH_MD,
        cardsPerSlide: CARDS_PER_SLIDE_MD,
        imageSize: CARD_IMG_SIZE_MD
    }
};

const RewardsCarousel = props => {
    const {
        showSkeleton = false,
        isModal = false,
        title,
        showMarketingFlags = false,
        showRankingNumbers = false,
        showLovesButton = false,
        showRatingWithCount = false,
        showQuickLookOnMobile = false,
        items,
        showPrice = false,
        size = 'small',
        customCardSize = {},
        showErrorModal = false,
        rougeBadgeText,
        analyticsContext,
        renderBiButton,
        hideVariationText = false,
        carouselName
    } = props;
    const component = PRODUCT_LIST;
    const sizeConfig = Object.assign({}, CardSizes[size], customCardSize);

    const triggerClick = function (target) {
        const eventData = mountCmsComponentEventData({
            items: [target],
            eventName: ITEM_CLICK,
            title,
            component
        });

        shouldSentEvent(eventData);
    };

    return (
        <Carousel
            isModal={isModal}
            isLoading={showSkeleton}
            gap={CARD_GAP}
            paddingY={4}
            marginX={isModal ? modal.outdentX : '-container'}
            scrollPadding={[2, isModal ? modal.paddingX[1] : 'container']}
            itemWidth={sizeConfig.cardWidth}
            hasShadowHack={!isModal}
            title={title}
            items={items.map((item, index) => (
                <ProductCard
                    key={item.skuId || item.sku?.skuId || index}
                    position={index}
                    isSkeleton={showSkeleton}
                    sku={showSkeleton ? {} : item.sku || item}
                    showPrice={showPrice}
                    showAddButton={true}
                    defaultRewardBiButton={renderBiButton}
                    useInternalTracking={true}
                    parentTitle={anaConstants.CAROUSEL_NAMES.REWARD_BAZAAR}
                    carouselName={carouselName}
                    showMarketingFlags={showMarketingFlags}
                    rank={showRankingNumbers ? index + 1 : null}
                    showLovesButton={showLovesButton}
                    showRating={showRatingWithCount}
                    imageSize={sizeConfig.imageSize}
                    showQuickLookOnMobile={showQuickLookOnMobile}
                    isHorizontal={size === 'horizontal'}
                    triggerCmsEvent={triggerClick}
                    showErrorModal={showErrorModal}
                    ctaTwoLines={false}
                    rougeBadgeText={rougeBadgeText}
                    analyticsContext={analyticsContext}
                    rootContainerName={anaConstants.CAROUSEL_NAMES.REWARD_BAZAAR}
                    isRewardItem={true}
                    isCarousel={true}
                    isBIRBReward={true}
                    hideVariationText={hideVariationText}
                />
            ))}
        />
    );
};

export default wrapFunctionalComponent(RewardsCarousel, 'RewardsCarousel');
